const compatModules = {};import * as Mod1 from "./discourse-akismet/connectors/flag-modal-bottom/akismet-status.gjs";
compatModules["discourse-akismet/connectors/flag-modal-bottom/akismet-status"] = Mod1;

export * as discourse__akismet$connectors$flag__modal__bottom$akismet__status$$__module from "./discourse-akismet/connectors/flag-modal-bottom/akismet-status.gjs";
export {
default as discourse__akismet$connectors$flag__modal__bottom$akismet__status$$default
} from "./discourse-akismet/connectors/flag-modal-bottom/akismet-status.gjs";
import * as Mod2 from "./discourse-akismet/connectors/topic-above-post-stream/topic-removed-notification.gjs";
compatModules["discourse-akismet/connectors/topic-above-post-stream/topic-removed-notification"] = Mod2;

export * as discourse__akismet$connectors$topic__above__post__stream$topic__removed__notification$$__module from "./discourse-akismet/connectors/topic-above-post-stream/topic-removed-notification.gjs";
export {
default as discourse__akismet$connectors$topic__above__post__stream$topic__removed__notification$$default
} from "./discourse-akismet/connectors/topic-above-post-stream/topic-removed-notification.gjs";
import * as Mod3 from "./discourse/components/reviewable-akismet-api-error";
compatModules["discourse/components/reviewable-akismet-api-error"] = Mod3;

export * as discourse$components$reviewable__akismet__api__error$$__module from "./discourse/components/reviewable-akismet-api-error";
export {
default as discourse$components$reviewable__akismet__api__error$$default
} from "./discourse/components/reviewable-akismet-api-error";
import * as Mod4 from "./discourse/components/reviewable/akismet-post-voting-comment";
compatModules["discourse/components/reviewable/akismet-post-voting-comment"] = Mod4;

export * as discourse$components$reviewable$akismet__post__voting__comment$$__module from "./discourse/components/reviewable/akismet-post-voting-comment";
export {
default as discourse$components$reviewable$akismet__post__voting__comment$$default
} from "./discourse/components/reviewable/akismet-post-voting-comment";
import * as Mod5 from "./discourse/components/reviewable/akismet-post";
compatModules["discourse/components/reviewable/akismet-post"] = Mod5;

export * as discourse$components$reviewable$akismet__post$$__module from "./discourse/components/reviewable/akismet-post";
export {
default as discourse$components$reviewable$akismet__post$$default
} from "./discourse/components/reviewable/akismet-post";
import * as Mod6 from "./discourse/components/reviewable/akismet-user";
compatModules["discourse/components/reviewable/akismet-user"] = Mod6;

export * as discourse$components$reviewable$akismet__user$$__module from "./discourse/components/reviewable/akismet-user";
export {
default as discourse$components$reviewable$akismet__user$$default
} from "./discourse/components/reviewable/akismet-user";
import * as Mod7 from "./discourse/initializers/add-akismet-state";
compatModules["discourse/initializers/add-akismet-state"] = Mod7;

export * as discourse$initializers$add__akismet__state$$__module from "./discourse/initializers/add-akismet-state";
export {
default as discourse$initializers$add__akismet__state$$default
} from "./discourse/initializers/add-akismet-state";
export default compatModules;
